module.exports = __webpack_public_path__ + "static/media/lp-splash.06c19a6f.png";